export const images_url_ad = 'images.alluradirect.com';
export const images_url_dv = 'images.directvacations.com';

//Direct Vacations Logo
export const dvLogo = `https://${images_url_ad}/DVLogos/default.gif`;
//Whistler.com Logo
export const whistlerSiteLogo = `https://${process.env.NEXT_PUBLIC_BASE_URL}/styles/images/whistler.com_444x125.jpg`;

export const noImagePlaceholder = `https://${images_url_ad}/Images/no_image_placeholder_300x200.png`;
export const loadingImagePlaceholder = `https://${images_url_ad}/Images/loading_image_placeholder_300x200.png`;
export const edittingImagePlaceholder = `https://${images_url_ad}/Images/editing_image_placeholder_300x200.png`;


export const logoInvert = `https://${process.env.NEXT_PUBLIC_BASE_URL}/styles/images/logo6-inverted.png`;
export const logoAlluraDirect = `https://${process.env.NEXT_PUBLIC_BASE_URL}/styles/images/alluradirect_logo.png`;
export const imageCheckSample = `https://${process.env.NEXT_PUBLIC_BASE_URL}/styles/images/check_sample.gif`;

export const logoInvertV2 = `https://${images_url_ad}/Images/logo-inverted-notag.png`;
export const dvListingPage = `https://${images_url_ad}/Images/dv-property-page.jpg`;
export const preOnboardingImage = `https://${images_url_ad}/Images/welcome-image-onboarding.png`;
export const websiteErrorImage = `https://${images_url_ad}/Images/website-error-image.png`;


export const propertyGuidebookImage = `https://${images_url_ad}/Images/v1email-guidebook.jpg`;
export const guestNoReservations = `https://${images_url_ad}/Images/guestNoReservations.png`;

export const standardMembershipImage = `https://${images_url_ad}/Images/listingPage-membershipStandard.png`;
export const premiumMembershipImage = `https://${images_url_ad}/Images/listingPage-membershipPremium.png`;

export const splashHomeTop = `https://${images_url_ad}/Images/splash-home-top.png`;

// Video Splash Images
export const threeSixtySplash = `https://${images_url_ad}/Images/360VideoExample.jpg`;
export const youTubeSplash = `https://${images_url_ad}/Images/YouTubeVideoExample.jpg`;

export const defaultPropertyProfileImage = `https://${images_url_ad}/Images/propertyProfile-default.png`;
export const defaultUserProfileImage = `https://${images_url_ad}/Images/userProfile-default.png`;

export const verifyImage = `https://${images_url_ad}/Images/undraw_verify-user.png`;

// List Page
export const headerVacationRentalsImage = `https://${images_url_ad}/Images/header-vacation-rental-home.png`;
export const headerVacationRentalSearchImage = `https://${images_url_ad}/Images/header-vacation-rental-search.png`;
export const headerVacationRentalListingImage =
  `https://${images_url_ad}/Images/header-vacation-rental-listing.png`;

export const listGuestSuitabilityImage = `https://${images_url_ad}/Images/list-guest-suitability.png`;
export const listSimpleManagementImage = `https://${images_url_ad}/Images/list-simple-management.png`;
export const listCommunitySupportImage = `https://${images_url_ad}/Images/list-community-support.png`;
export const listGuidebookGuestImage = `https://${images_url_ad}/Images/list-property-guidebook-guest.png`;

export const listDirectBookingsImage = `https://${images_url_ad}/Images/list-direct-bookings.png`;
export const listPropertyBenefitsImage = `https://${images_url_ad}/Images/list-property-benefits.png`;
export const listAirbnbVrboImage = `https://${images_url_ad}/Images/list-airbnb-vrbo-compatible.png`;
export const listPropertyOnboardingImage = `https://${images_url_ad}/Images/list-property-onboarding.jpg`;

export const listSmallRentalPolicyImage = `https://${images_url_ad}/Images/list-small-rental-policies.png`;
export const listSmallCalendarImage = `https://${images_url_ad}/Images/list-small-calendar-availability.png`;
export const listSmallRatesPricingImage = `https://${images_url_ad}/Images/list-small-rates-pricing.png`;
export const listPropertyPayouts = `https://${images_url_ad}/Images/list-property-taxes-payouts.jpg`;
export const listMobileApplicationImage = `https://${images_url_ad}/Images/list-mobile-application.png`;

export const listAlluraDirectImage = `https://${images_url_ad}/Images/list-alluradirect-logo.png`;
export const listWhistlerLogo = `https://${images_url_ad}/Images/list-whistler-logo.png`;
export const whistlerBlackombLogo = `https://${images_url_ad}/Images/list-whistler-blackcomb-logo.png`;
export const partnerQuestionLogo = `https://${images_url_ad}/Images/list-partner-question.jpg`;
export const listClientHappyImage = `https://${images_url_ad}/Images/list-alluradirect-client-happy.jpg`;
export const listMembershipStandardImage = `https://${images_url_ad}/Images/listingPage-membershipStandard.png`;
export const listMobileHeaderVacationImage = `https://${images_url_ad}/Images/mobile-header-vacation-images.png`;
export const listPropertyCalendarSyncImage = `https://${images_url_ad}/Images/list-property-calendar-sync.jpg`;
export const checkoutRefer = `https://${images_url_ad}/Images/example-checkout-refer.png`;

export const listPageEmailVerification = `https://${images_url_ad}/Images/undraw_verify-user.png`;

// THESE TWO ARE THE EXACT SAME IMAGE???
export const signUpPageFeeScreenGuestImage = `https://${images_url_ad}/Images/signup-page-feescreen.jpg`;
export const signUpPageFeeScreenHostImage = `https://${images_url_ad}/Images/login-page-ratescreen.jpg`;

export const facebookIcon = `https://${images_url_ad}/Images/facebook-share-icon.png`

// RateAutmoationDialog
export const rateAutomationExample1 = `https://${images_url_ad}/Images/rateautomation-example1.jpg`;
export const rateAutomationExample2 = `https://${images_url_ad}/Images/rateautomation-example2.jpg`;
export const rateAutomationExample3 = `https://${images_url_ad}/Images/rateautomation-example3.jpg`;
export const rateAutomationExample4 = `https://${images_url_ad}/Images/rateautomation-example4.jpg`;

// CheckoutDownloadMobileApp
export const androidStoreBadge = `https://${images_url_ad}/Images/store-android-badge.png`;
export const appleStoreBadge = `https://${images_url_ad}/Images/store-apple-badge.png`;
export const qrAppStoreBadge = `https://${images_url_ad}/Images/qr-appstore-small.jpg`;

// ListBase
export const listProperty = `https://${images_url_ad}/Images/alluradirect-og-listproperty.jpg`;

// UserTestimonials
export const hostReview733 = `https://${images_url_ad}/Images/hostReview733.jpg`;
export const hostReview848 = `https://${images_url_ad}/Images/hostReview848.jpg`;
export const hostReview3850 = `https://${images_url_ad}/Images/hostReview3850.jpg`;
export const tempProfileIcon = `https://${images_url_ad}/Images/temp-profile.jpg`;

export const propertyGuidebookMobile = `https://${images_url_ad}/Images/alluraMobile-screens-guidebook.png`;
export const createReservationMobile = `https://${images_url_ad}/Images/alluraMobile-screens-createRes.png`;
export const notificationScreenMobile = `https://${images_url_ad}/Images/alluraMobile-screens-notification.png`;

export const alluraReferralQuickstart = `https://${images_url_ad}/Images/alluraDirect_refer_quickstart.png`;
export const alluraReferralCommunity = `https://${images_url_ad}/Images/alluraDirect_refer_community.png`;

export const inquirySelectMessage = `https://${images_url_ad}/Images/inquiry-select-message.png`;
export const mobileAppCommunicate = `https://${images_url_ad}/Images/alluraMobile-screens-communicate.png`;
export const mobileAppReservations = `https://${images_url_ad}/Images/alluraMobile-screens-reviewInfo.png`;
export const mobileAppManageReservations = `https://${images_url_ad}/Images/alluraMobile-screens-manageReservations.png`;
export const mobileAppCode = `https://${images_url_ad}/Images/alluraMobile-screens-code.png`;

export const bigWhitePerk = "https://images.alluradirect.com/Images/bigwhitepass-perk-header.jpg";
export const snowvana2024 = "https://images.alluradirect.com/Images/snowvana2024logo.jpg";




